import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api, errMsg, fmtDate, fmtNum } from "@/lib/api";
import { PassBadge } from "@/components/ResultTable";

const MEDAL = { 1: "bg-amber-400 text-slate-950", 2: "bg-slate-300 text-slate-800", 3: "bg-orange-300 text-orange-950" };

const Row = ({ r, testid, showStatus }) => (
  <tr className={`border-t ${r.is_me ? "bg-amber-50 font-semibold" : ""}`} data-testid={testid}>
    <td className="px-4 py-2.5"><span className={`inline-flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold ${MEDAL[r.rank] || "bg-slate-100 text-slate-600"}`}>{r.rank}</span></td>
    <td className="py-2.5">{r.name}{r.is_me && <span className="ml-2 text-[10px] font-bold uppercase text-amber-700">Anda</span>}</td>
    <td className="hidden py-2.5 text-xs text-slate-500 sm:table-cell">{fmtDate(r.finished_at)}</td>
    {showStatus && <td className="py-2.5"><PassBadge passed={r.passed} /></td>}
    <td className="whitespace-nowrap py-2.5 pr-4 text-right font-mono font-bold text-[#0A192F]">{fmtNum(r.total)}<span className="text-xs text-slate-400">/{fmtNum(r.max_total)}</span></td>
  </tr>
);

export const Leaderboard = ({ packageId }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/packages/${packageId}/leaderboard`).then((r) => {
      setD(r.data);
      if (window.location.hash === "#peringkat") setTimeout(() => document.getElementById("peringkat")?.scrollIntoView({ behavior: "smooth" }), 50);
    }).catch((e) => setErr(errMsg(e)));
  }, [packageId]);
  const showStatus = !!d && d.top.some((r) => r.passed !== null && r.passed !== undefined);
  return (
    <div id="peringkat" className="card-premium p-6" data-testid="leaderboard">
      <h2 className="flex items-center gap-2 font-display text-lg font-bold text-[#0A192F]"><Trophy className="h-5 w-5 text-amber-500" />Papan Peringkat</h2>
      <p className="mt-1 text-xs text-slate-500">Skor terbaik tiap peserta. Skor sama mendapat peringkat sama.</p>
      {err ? <p className="mt-4 text-sm text-slate-500" data-testid="leaderboard-error">{err}</p> : !d ? <p className="mt-4 text-sm text-slate-500">Memuat...</p> : d.top.length === 0 ? (
        <p className="mt-4 text-sm text-slate-500" data-testid="leaderboard-empty">Belum ada peserta yang menyelesaikan paket ini.</p>
      ) : (
        <>
          {d.me && <p className="mt-3 rounded-lg bg-[#0A192F] px-4 py-2 text-sm text-white" data-testid="leaderboard-my-rank">Peringkat Anda: <b className="text-amber-300">#{d.me.rank}</b> dari {d.participants} peserta</p>}
          <div className="mt-3 max-h-[480px] overflow-auto rounded-lg border">
            <table className="w-full text-sm" data-testid="leaderboard-table">
              <thead className="sticky top-0 bg-slate-50 text-left text-xs uppercase text-slate-500"><tr><th className="px-4 py-2">#</th><th>Nama</th><th className="hidden sm:table-cell">Tanggal</th>{showStatus && <th>Status</th>}<th className="pr-4 text-right">Total</th></tr></thead>
              <tbody>
                {d.top.map((r, i) => <Row key={i} r={r} showStatus={showStatus} testid={`leaderboard-row-${i + 1}`} />)}
                {d.me && !d.top.some((r) => r.is_me) && <Row r={d.me} showStatus={showStatus} testid="leaderboard-row-me" />}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};
